import React, { useEffect, useState } from 'react';
import Card from '../../components/elements/Card';
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showNotification } from '../../utilities/mantineNotification';
import moment from 'moment';
import {
  HttpService,
  getSharepointCdnFile,
  getSharepointCdnFileMedia
} from '../../utilities';
import {
  Avatar,
  Button,
  Flex,
  Image,
  Indicator,
  Popover,
  Tabs,
  Text,
  ThemeIcon,
  Title
} from '@mantine/core';
import {
  FiGift,
  FiPaperclip,
  FiPauseCircle,
  FiTerminal,
  FiUser
} from 'react-icons/fi';
import { CgGoogleTasks } from 'react-icons/cg';
import { TiSpiral } from 'react-icons/ti';
import {
  getNotification,
  getTodoList,
  postNotifClicked,
  seeAll
} from '../../services/notification';
import { Link } from 'react-router-dom';
import { ApiKeys, ApiService } from '../../constants';
import NoDataText from '../../components/no_data_text';
import FailedIllustration from '../../components/fragments/IllustrationState/FailedIllustration';
import NoData from '../../components/fragments/IllustrationState/NoData';

const renderImage = (item) => {
  return (
    <Popover width={200} position="bottom" withArrow shadow="md">
      <Popover.Target>
        <Image
          src={getSharepointCdnFileMedia(item.levelImage)}
          w={40}
          radius="md"
          style={{ cursor: 'pointer' }}
        />
      </Popover.Target>

      <Popover.Dropdown>
        <Image
          src={getSharepointCdnFileMedia(item.levelImage)}
          width={'100%'}
        />
      </Popover.Dropdown>
    </Popover>
  );
};

const Notif = (props) => {
  const [listTask, setListTask] = useState([]);
  const fetchedNotif = useQuery({
    queryKey: ['getNotification'],
    queryFn: () => getNotification({})
  });

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    return JSON.parse(object.auth).userData;
  };

  useEffect(() => {
    const _userData = getUserData();
    requestGetTodoList(_userData.binusianId);
  }, []);

  const requestGetTodoList = (binusianId) => {
    console.log('LayoutHeaderNotification requestGetTodoList');
    // binusianId = '1601246934';
    const payload = {
      BinusianId: binusianId
    };
    HttpService.post(ApiService.beelajar.getTodoList, payload)
      .then((resp) => {
        setListTask(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const clickedNotif = useMutation({
    mutationFn: postNotifClicked,
    onSuccess: () => {
      fetchedNotif.refetch();
      // fetchedNotif.mutate();
      showNotification({
        type: 'success',
        title: 'Success update status view Notification',
        message: 'Updated data will be show in the list notification'
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const onClickedSeeAll = useMutation({
    mutationFn: seeAll,
    onSuccess: () => {
      fetchedNotif.refetch();
      showNotification({
        type: 'success',
        title: 'Success update all status view Notification',
        message: 'Updated data will be show in the list notification'
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleNotifClicked = (id) => {
    clickedNotif.mutate({ notifikasiID: id });
  };

  const handleSeeAll = () => {
    onClickedSeeAll.mutate({});
  };

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Notification"
        itemList={[
          {
            title: 'Profile',
            href: '/profile',
            icon: <FiUser />
          },
          {
            title: 'Notification',
            href: 'profile/notification'
          }
        ]}
      />
      <Card>
        <Tabs defaultValue="task">
          <Tabs.List>
            <Tabs.Tab value="task">
              <Title order={5}>
                Task (
                {
                  listTask?.filter((item) => item.progress === 'Not Completed')
                    .length
                }
                )
              </Title>
            </Tabs.Tab>
            <Tabs.Tab value="history">
              <Title order={5}>
                History (
                {
                  fetchedNotif?.data?.data?.data?.filter(
                    (item) => item.isView === false
                  ).length
                }
                )
              </Title>
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="task">
            <Tabs.Panel value="task">
              {listTask?.length === 0 ? (
                <NoData
                  description="There's no task for you, at least for now :)"
                  title="No Task Available"
                />
              ) : (
                listTask?.map((item, index) => (
                  <Flex
                    onClick={() => {
                      HttpService.goToBeelajar(item.email, item.url);
                    }}
                    key={index}
                    style={{
                      cursor: 'pointer',
                      marginTop: '20px'
                    }}
                    direction={{ base: 'column', sm: 'row' }}
                    gap={{ base: 'sm', sm: 'lg' }}
                    align={{ sm: 'center' }}
                  >
                    <Indicator
                      color="red"
                      inline
                      processing
                      disabled={
                        item.progress === 'Not Completed' ? false : true
                      }
                    >
                      <ThemeIcon color="#F7DFF9" size="xl">
                        <CgGoogleTasks
                          style={{ width: '70%', height: '70%' }}
                          color="#7B2183"
                        />
                      </ThemeIcon>
                    </Indicator>
                    <div>
                      <Title order={5}>{item.activityname}</Title>
                      <Text size="sm">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.coursename
                          }}
                        />
                      </Text>
                    </div>
                  </Flex>
                ))
              )}
            </Tabs.Panel>
          </Tabs.Panel>

          <Tabs.Panel value="history">
            {fetchedNotif?.data?.data?.data.length === 0 ? (
              <FailedIllustration
                description="There is no notification at the moment, try again later."
                title="No Notification Available"
              />
            ) : (
              <div>
                {fetchedNotif?.data?.data?.data?.filter(
                  (item) => item.isView === false
                ).length > 0 && (
                  <Button
                    fullWidth
                    mt={10}
                    color="blue"
                    onClick={() => {
                      handleSeeAll();
                    }}
                  >
                    Mark All as Read
                  </Button>
                )}

                {fetchedNotif?.data?.data?.data?.map((item, index) => (
                  <Link
                    key={index}
                    onClick={() => {
                      if (!item.isView) handleNotifClicked(item.notifikasiID);
                    }}
                    to={
                      item.jenisNotif === 'inject-point'
                        ? './notification'
                        : item.jenisNotif === 'new-mission'
                        ? item.missionID !== null
                          ? `/mission/${item.missionID}`
                          : '/rnb/mission'
                        : '../' + item.link
                    }
                    style={{
                      textDecoration: 'none',
                      color: 'black'
                    }}
                  >
                    <Flex
                      key={index}
                      style={{
                        marginTop: '20px'
                      }}
                      direction={{ base: 'column', sm: 'row' }}
                      gap={{ base: 'sm', sm: 'lg' }}
                      align={{ sm: 'center' }}
                    >
                      <Indicator
                        color="red"
                        inline
                        processing
                        disabled={item.isView}
                      >
                        <ThemeIcon color="#F7DFF9" size="xl">
                          {item.jenisNotif === 'new-mission' ? (
                            <TiSpiral
                              style={{ width: '70%', height: '70%' }}
                              color="#7B2183"
                            />
                          ) : (
                            <FiGift
                              style={{ width: '50%', height: '50%' }}
                              color="#7B2183"
                            />
                          )}
                        </ThemeIcon>
                      </Indicator>
                      <div>
                        <Title order={5}>
                          {item.jenisNotif === 'inject-point'
                            ? 'Bonus Point'
                            : item.title}
                        </Title>
                        <Text size="sm">
                          <div
                            dangerouslySetInnerHTML={{ __html: item.subTitle }}
                          />
                        </Text>
                        <Text
                          size="xs"
                          style={{
                            color: 'gray',
                            fontWeight: 'bold'
                          }}
                        >
                          {moment(item.dateIn).calendar()}
                        </Text>
                      </div>
                    </Flex>
                  </Link>
                ))}
              </div>
            )}
          </Tabs.Panel>
        </Tabs>
      </Card>
    </AdminLayout>
  );
};

// function to format date
const getDateFormat = (date) => {
  const d = new Date(date);
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
  return `${da} ${mo} ${ye}`;
};

export default Notif;
